module.exports = __webpack_public_path__ + "static/media/vt.160b8f9f.svg";